<template>
<div :class="'percentage-circle circle-'+value+' circle-yellow'"><span>{{value}}</span></div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true,
      default: 0,
    },
  },
};
</script>

<style scoped>


.percentage-circle {
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/ */
  background-image: #3783c5;
  /* Old browsers */
  background-image: -moz-linear-gradient(left, #3783c5 0%, #3783c5 50%, #dc58a2 50%, #dc58a2 100%);
  /* FF3.6-15 */
  background-image: -webkit-linear-gradient(left, #3783c5 0%, #3783c5 50%, #dc58a2 50%, #dc58a2 100%);
  /* Chrome10-25,Safari5.1-6 */
  background-image: linear-gradient(to right, #3783c5 0%, #3783c5 50%, #dc58a2 50%, #dc58a2 100%);
  /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="$start-color", endColorstr="$end-color",GradientType=1 );
  /* IE6-9 */
  position: relative;
  width: 66px;
  height: 66px;
  background-color: #3783c5;
  border-radius: 50%;
}
.percentage-circle:before, .percentage-circle:after {
  content: "";
  display: block;
}
.percentage-circle:before {
  margin-left: 50%;
  height: 100%;
  transform-origin: left;
  border-radius: 0 100% 100% 0/50%;
}
.percentage-circle:after {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  border-radius: 50%;
  background: #1469B3;
  width: 50px;
  height: 50px;
  z-index: 10;
}
.percentage-circle span {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;

  display: block;
  width: 100%;
  height: 20px;
  font-size: 17px;
  line-height: 1;
  letter-spacing: 1px;
  text-align: center;
  z-index: 50;
  font-weight: 700;
}


.percentage-circle.circle-yellow {
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/ */
  background-image: #B38D2F;
  /* Old browsers */
  background-image: -moz-linear-gradient(left, #3783c5 0%, #3783c5 50%, #B38D2F 50%, #B38D2F 100%);
  /* FF3.6-15 */
  background-image: -webkit-linear-gradient(left, #3783c5 0%, #3783c5 50%, #B38D2F 50%, #B38D2F 100%);
  /* Chrome10-25,Safari5.1-6 */
  background-image: linear-gradient(to right, #3783c5 0%, #3783c5 50%, #B38D2F 50%, #B38D2F 100%);
  /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="$start-color", endColorstr="$end-color",GradientType=1 );
  /* IE6-9 */
}
.percentage-circle.circle-yellow span {
  color: #FFF;
}


.circle-1:before {
  background-color: inherit;
  -webkit-transform: rotate(3.6deg);
  -moz-transform: rotate(3.6deg);
  -ms-transform: rotate(3.6deg);
  -o-transform: rotate(3.6deg);
  transform: rotate(3.6deg);
}

.circle-2:before {
  background-color: inherit;
  -webkit-transform: rotate(7.2deg);
  -moz-transform: rotate(7.2deg);
  -ms-transform: rotate(7.2deg);
  -o-transform: rotate(7.2deg);
  transform: rotate(7.2deg);
}

.circle-3:before {
  background-color: inherit;
  -webkit-transform: rotate(10.8deg);
  -moz-transform: rotate(10.8deg);
  -ms-transform: rotate(10.8deg);
  -o-transform: rotate(10.8deg);
  transform: rotate(10.8deg);
}

.circle-4:before {
  background-color: inherit;
  -webkit-transform: rotate(14.4deg);
  -moz-transform: rotate(14.4deg);
  -ms-transform: rotate(14.4deg);
  -o-transform: rotate(14.4deg);
  transform: rotate(14.4deg);
}

.circle-5:before {
  background-color: inherit;
  -webkit-transform: rotate(18deg);
  -moz-transform: rotate(18deg);
  -ms-transform: rotate(18deg);
  -o-transform: rotate(18deg);
  transform: rotate(18deg);
}

.circle-6:before {
  background-color: inherit;
  -webkit-transform: rotate(21.6deg);
  -moz-transform: rotate(21.6deg);
  -ms-transform: rotate(21.6deg);
  -o-transform: rotate(21.6deg);
  transform: rotate(21.6deg);
}

.circle-7:before {
  background-color: inherit;
  -webkit-transform: rotate(25.2deg);
  -moz-transform: rotate(25.2deg);
  -ms-transform: rotate(25.2deg);
  -o-transform: rotate(25.2deg);
  transform: rotate(25.2deg);
}

.circle-8:before {
  background-color: inherit;
  -webkit-transform: rotate(28.8deg);
  -moz-transform: rotate(28.8deg);
  -ms-transform: rotate(28.8deg);
  -o-transform: rotate(28.8deg);
  transform: rotate(28.8deg);
}

.circle-9:before {
  background-color: inherit;
  -webkit-transform: rotate(32.4deg);
  -moz-transform: rotate(32.4deg);
  -ms-transform: rotate(32.4deg);
  -o-transform: rotate(32.4deg);
  transform: rotate(32.4deg);
}

.circle-10:before {
  background-color: inherit;
  -webkit-transform: rotate(36deg);
  -moz-transform: rotate(36deg);
  -ms-transform: rotate(36deg);
  -o-transform: rotate(36deg);
  transform: rotate(36deg);
}

.circle-11:before {
  background-color: inherit;
  -webkit-transform: rotate(39.6deg);
  -moz-transform: rotate(39.6deg);
  -ms-transform: rotate(39.6deg);
  -o-transform: rotate(39.6deg);
  transform: rotate(39.6deg);
}

.circle-12:before {
  background-color: inherit;
  -webkit-transform: rotate(43.2deg);
  -moz-transform: rotate(43.2deg);
  -ms-transform: rotate(43.2deg);
  -o-transform: rotate(43.2deg);
  transform: rotate(43.2deg);
}

.circle-13:before {
  background-color: inherit;
  -webkit-transform: rotate(46.8deg);
  -moz-transform: rotate(46.8deg);
  -ms-transform: rotate(46.8deg);
  -o-transform: rotate(46.8deg);
  transform: rotate(46.8deg);
}

.circle-14:before {
  background-color: inherit;
  -webkit-transform: rotate(50.4deg);
  -moz-transform: rotate(50.4deg);
  -ms-transform: rotate(50.4deg);
  -o-transform: rotate(50.4deg);
  transform: rotate(50.4deg);
}

.circle-15:before {
  background-color: inherit;
  -webkit-transform: rotate(54deg);
  -moz-transform: rotate(54deg);
  -ms-transform: rotate(54deg);
  -o-transform: rotate(54deg);
  transform: rotate(54deg);
}

.circle-16:before {
  background-color: inherit;
  -webkit-transform: rotate(57.6deg);
  -moz-transform: rotate(57.6deg);
  -ms-transform: rotate(57.6deg);
  -o-transform: rotate(57.6deg);
  transform: rotate(57.6deg);
}

.circle-17:before {
  background-color: inherit;
  -webkit-transform: rotate(61.2deg);
  -moz-transform: rotate(61.2deg);
  -ms-transform: rotate(61.2deg);
  -o-transform: rotate(61.2deg);
  transform: rotate(61.2deg);
}

.circle-18:before {
  background-color: inherit;
  -webkit-transform: rotate(64.8deg);
  -moz-transform: rotate(64.8deg);
  -ms-transform: rotate(64.8deg);
  -o-transform: rotate(64.8deg);
  transform: rotate(64.8deg);
}

.circle-19:before {
  background-color: inherit;
  -webkit-transform: rotate(68.4deg);
  -moz-transform: rotate(68.4deg);
  -ms-transform: rotate(68.4deg);
  -o-transform: rotate(68.4deg);
  transform: rotate(68.4deg);
}

.circle-20:before {
  background-color: inherit;
  -webkit-transform: rotate(72deg);
  -moz-transform: rotate(72deg);
  -ms-transform: rotate(72deg);
  -o-transform: rotate(72deg);
  transform: rotate(72deg);
}

.circle-21:before {
  background-color: inherit;
  -webkit-transform: rotate(75.6deg);
  -moz-transform: rotate(75.6deg);
  -ms-transform: rotate(75.6deg);
  -o-transform: rotate(75.6deg);
  transform: rotate(75.6deg);
}

.circle-22:before {
  background-color: inherit;
  -webkit-transform: rotate(79.2deg);
  -moz-transform: rotate(79.2deg);
  -ms-transform: rotate(79.2deg);
  -o-transform: rotate(79.2deg);
  transform: rotate(79.2deg);
}

.circle-23:before {
  background-color: inherit;
  -webkit-transform: rotate(82.8deg);
  -moz-transform: rotate(82.8deg);
  -ms-transform: rotate(82.8deg);
  -o-transform: rotate(82.8deg);
  transform: rotate(82.8deg);
}

.circle-24:before {
  background-color: inherit;
  -webkit-transform: rotate(86.4deg);
  -moz-transform: rotate(86.4deg);
  -ms-transform: rotate(86.4deg);
  -o-transform: rotate(86.4deg);
  transform: rotate(86.4deg);
}

.circle-25:before {
  background-color: inherit;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

.circle-26:before {
  background-color: inherit;
  -webkit-transform: rotate(93.6deg);
  -moz-transform: rotate(93.6deg);
  -ms-transform: rotate(93.6deg);
  -o-transform: rotate(93.6deg);
  transform: rotate(93.6deg);
}

.circle-27:before {
  background-color: inherit;
  -webkit-transform: rotate(97.2deg);
  -moz-transform: rotate(97.2deg);
  -ms-transform: rotate(97.2deg);
  -o-transform: rotate(97.2deg);
  transform: rotate(97.2deg);
}

.circle-28:before {
  background-color: inherit;
  -webkit-transform: rotate(100.8deg);
  -moz-transform: rotate(100.8deg);
  -ms-transform: rotate(100.8deg);
  -o-transform: rotate(100.8deg);
  transform: rotate(100.8deg);
}

.circle-29:before {
  background-color: inherit;
  -webkit-transform: rotate(104.4deg);
  -moz-transform: rotate(104.4deg);
  -ms-transform: rotate(104.4deg);
  -o-transform: rotate(104.4deg);
  transform: rotate(104.4deg);
}

.circle-30:before {
  background-color: inherit;
  -webkit-transform: rotate(108deg);
  -moz-transform: rotate(108deg);
  -ms-transform: rotate(108deg);
  -o-transform: rotate(108deg);
  transform: rotate(108deg);
}

.circle-31:before {
  background-color: inherit;
  -webkit-transform: rotate(111.6deg);
  -moz-transform: rotate(111.6deg);
  -ms-transform: rotate(111.6deg);
  -o-transform: rotate(111.6deg);
  transform: rotate(111.6deg);
}

.circle-32:before {
  background-color: inherit;
  -webkit-transform: rotate(115.2deg);
  -moz-transform: rotate(115.2deg);
  -ms-transform: rotate(115.2deg);
  -o-transform: rotate(115.2deg);
  transform: rotate(115.2deg);
}

.circle-33:before {
  background-color: inherit;
  -webkit-transform: rotate(118.8deg);
  -moz-transform: rotate(118.8deg);
  -ms-transform: rotate(118.8deg);
  -o-transform: rotate(118.8deg);
  transform: rotate(118.8deg);
}

.circle-34:before {
  background-color: inherit;
  -webkit-transform: rotate(122.4deg);
  -moz-transform: rotate(122.4deg);
  -ms-transform: rotate(122.4deg);
  -o-transform: rotate(122.4deg);
  transform: rotate(122.4deg);
}

.circle-35:before {
  background-color: inherit;
  -webkit-transform: rotate(126deg);
  -moz-transform: rotate(126deg);
  -ms-transform: rotate(126deg);
  -o-transform: rotate(126deg);
  transform: rotate(126deg);
}

.circle-36:before {
  background-color: inherit;
  -webkit-transform: rotate(129.6deg);
  -moz-transform: rotate(129.6deg);
  -ms-transform: rotate(129.6deg);
  -o-transform: rotate(129.6deg);
  transform: rotate(129.6deg);
}

.circle-37:before {
  background-color: inherit;
  -webkit-transform: rotate(133.2deg);
  -moz-transform: rotate(133.2deg);
  -ms-transform: rotate(133.2deg);
  -o-transform: rotate(133.2deg);
  transform: rotate(133.2deg);
}

.circle-38:before {
  background-color: inherit;
  -webkit-transform: rotate(136.8deg);
  -moz-transform: rotate(136.8deg);
  -ms-transform: rotate(136.8deg);
  -o-transform: rotate(136.8deg);
  transform: rotate(136.8deg);
}

.circle-39:before {
  background-color: inherit;
  -webkit-transform: rotate(140.4deg);
  -moz-transform: rotate(140.4deg);
  -ms-transform: rotate(140.4deg);
  -o-transform: rotate(140.4deg);
  transform: rotate(140.4deg);
}

.circle-40:before {
  background-color: inherit;
  -webkit-transform: rotate(144deg);
  -moz-transform: rotate(144deg);
  -ms-transform: rotate(144deg);
  -o-transform: rotate(144deg);
  transform: rotate(144deg);
}

.circle-41:before {
  background-color: inherit;
  -webkit-transform: rotate(147.6deg);
  -moz-transform: rotate(147.6deg);
  -ms-transform: rotate(147.6deg);
  -o-transform: rotate(147.6deg);
  transform: rotate(147.6deg);
}

.circle-42:before {
  background-color: inherit;
  -webkit-transform: rotate(151.2deg);
  -moz-transform: rotate(151.2deg);
  -ms-transform: rotate(151.2deg);
  -o-transform: rotate(151.2deg);
  transform: rotate(151.2deg);
}

.circle-43:before {
  background-color: inherit;
  -webkit-transform: rotate(154.8deg);
  -moz-transform: rotate(154.8deg);
  -ms-transform: rotate(154.8deg);
  -o-transform: rotate(154.8deg);
  transform: rotate(154.8deg);
}

.circle-44:before {
  background-color: inherit;
  -webkit-transform: rotate(158.4deg);
  -moz-transform: rotate(158.4deg);
  -ms-transform: rotate(158.4deg);
  -o-transform: rotate(158.4deg);
  transform: rotate(158.4deg);
}

.circle-45:before {
  background-color: inherit;
  -webkit-transform: rotate(162deg);
  -moz-transform: rotate(162deg);
  -ms-transform: rotate(162deg);
  -o-transform: rotate(162deg);
  transform: rotate(162deg);
}

.circle-46:before {
  background-color: inherit;
  -webkit-transform: rotate(165.6deg);
  -moz-transform: rotate(165.6deg);
  -ms-transform: rotate(165.6deg);
  -o-transform: rotate(165.6deg);
  transform: rotate(165.6deg);
}

.circle-47:before {
  background-color: inherit;
  -webkit-transform: rotate(169.2deg);
  -moz-transform: rotate(169.2deg);
  -ms-transform: rotate(169.2deg);
  -o-transform: rotate(169.2deg);
  transform: rotate(169.2deg);
}

.circle-48:before {
  background-color: inherit;
  -webkit-transform: rotate(172.8deg);
  -moz-transform: rotate(172.8deg);
  -ms-transform: rotate(172.8deg);
  -o-transform: rotate(172.8deg);
  transform: rotate(172.8deg);
}

.circle-49:before {
  background-color: inherit;
  -webkit-transform: rotate(176.4deg);
  -moz-transform: rotate(176.4deg);
  -ms-transform: rotate(176.4deg);
  -o-transform: rotate(176.4deg);
  transform: rotate(176.4deg);
}

.circle-50:before {
  background-color: inherit;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

.circle-51:before {
  -webkit-transform: rotate(3.6deg);
  -moz-transform: rotate(3.6deg);
  -ms-transform: rotate(3.6deg);
  -o-transform: rotate(3.6deg);
  transform: rotate(3.6deg);
}
.circle-51.circle-red:before {
  background-color: #f44a5f;
}
.circle-51.circle-orange:before {
  background-color: #ffb802;
}
.circle-51.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-51.circle-green:before {
  background-color: #00b48c;
}

.circle-52:before {
  -webkit-transform: rotate(7.2deg);
  -moz-transform: rotate(7.2deg);
  -ms-transform: rotate(7.2deg);
  -o-transform: rotate(7.2deg);
  transform: rotate(7.2deg);
}
.circle-52.circle-red:before {
  background-color: #f44a5f;
}
.circle-52.circle-orange:before {
  background-color: #ffb802;
}
.circle-52.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-52.circle-green:before {
  background-color: #00b48c;
}

.circle-53:before {
  -webkit-transform: rotate(10.8deg);
  -moz-transform: rotate(10.8deg);
  -ms-transform: rotate(10.8deg);
  -o-transform: rotate(10.8deg);
  transform: rotate(10.8deg);
}
.circle-53.circle-red:before {
  background-color: #f44a5f;
}
.circle-53.circle-orange:before {
  background-color: #ffb802;
}
.circle-53.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-53.circle-green:before {
  background-color: #00b48c;
}

.circle-54:before {
  -webkit-transform: rotate(14.4deg);
  -moz-transform: rotate(14.4deg);
  -ms-transform: rotate(14.4deg);
  -o-transform: rotate(14.4deg);
  transform: rotate(14.4deg);
}
.circle-54.circle-red:before {
  background-color: #f44a5f;
}
.circle-54.circle-orange:before {
  background-color: #ffb802;
}
.circle-54.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-54.circle-green:before {
  background-color: #00b48c;
}

.circle-55:before {
  -webkit-transform: rotate(18deg);
  -moz-transform: rotate(18deg);
  -ms-transform: rotate(18deg);
  -o-transform: rotate(18deg);
  transform: rotate(18deg);
}
.circle-55.circle-red:before {
  background-color: #f44a5f;
}
.circle-55.circle-orange:before {
  background-color: #ffb802;
}
.circle-55.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-55.circle-green:before {
  background-color: #00b48c;
}

.circle-56:before {
  -webkit-transform: rotate(21.6deg);
  -moz-transform: rotate(21.6deg);
  -ms-transform: rotate(21.6deg);
  -o-transform: rotate(21.6deg);
  transform: rotate(21.6deg);
}
.circle-56.circle-red:before {
  background-color: #f44a5f;
}
.circle-56.circle-orange:before {
  background-color: #ffb802;
}
.circle-56.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-56.circle-green:before {
  background-color: #00b48c;
}

.circle-57:before {
  -webkit-transform: rotate(25.2deg);
  -moz-transform: rotate(25.2deg);
  -ms-transform: rotate(25.2deg);
  -o-transform: rotate(25.2deg);
  transform: rotate(25.2deg);
}
.circle-57.circle-red:before {
  background-color: #f44a5f;
}
.circle-57.circle-orange:before {
  background-color: #ffb802;
}
.circle-57.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-57.circle-green:before {
  background-color: #00b48c;
}

.circle-58:before {
  -webkit-transform: rotate(28.8deg);
  -moz-transform: rotate(28.8deg);
  -ms-transform: rotate(28.8deg);
  -o-transform: rotate(28.8deg);
  transform: rotate(28.8deg);
}
.circle-58.circle-red:before {
  background-color: #f44a5f;
}
.circle-58.circle-orange:before {
  background-color: #ffb802;
}
.circle-58.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-58.circle-green:before {
  background-color: #00b48c;
}

.circle-59:before {
  -webkit-transform: rotate(32.4deg);
  -moz-transform: rotate(32.4deg);
  -ms-transform: rotate(32.4deg);
  -o-transform: rotate(32.4deg);
  transform: rotate(32.4deg);
}
.circle-59.circle-red:before {
  background-color: #f44a5f;
}
.circle-59.circle-orange:before {
  background-color: #ffb802;
}
.circle-59.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-59.circle-green:before {
  background-color: #00b48c;
}

.circle-60:before {
  -webkit-transform: rotate(36deg);
  -moz-transform: rotate(36deg);
  -ms-transform: rotate(36deg);
  -o-transform: rotate(36deg);
  transform: rotate(36deg);
}
.circle-60.circle-red:before {
  background-color: #f44a5f;
}
.circle-60.circle-orange:before {
  background-color: #ffb802;
}
.circle-60.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-60.circle-green:before {
  background-color: #00b48c;
}

.circle-61:before {
  -webkit-transform: rotate(39.6deg);
  -moz-transform: rotate(39.6deg);
  -ms-transform: rotate(39.6deg);
  -o-transform: rotate(39.6deg);
  transform: rotate(39.6deg);
}
.circle-61.circle-red:before {
  background-color: #f44a5f;
}
.circle-61.circle-orange:before {
  background-color: #ffb802;
}
.circle-61.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-61.circle-green:before {
  background-color: #00b48c;
}

.circle-62:before {
  -webkit-transform: rotate(43.2deg);
  -moz-transform: rotate(43.2deg);
  -ms-transform: rotate(43.2deg);
  -o-transform: rotate(43.2deg);
  transform: rotate(43.2deg);
}
.circle-62.circle-red:before {
  background-color: #f44a5f;
}
.circle-62.circle-orange:before {
  background-color: #ffb802;
}
.circle-62.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-62.circle-green:before {
  background-color: #00b48c;
}

.circle-63:before {
  -webkit-transform: rotate(46.8deg);
  -moz-transform: rotate(46.8deg);
  -ms-transform: rotate(46.8deg);
  -o-transform: rotate(46.8deg);
  transform: rotate(46.8deg);
}
.circle-63.circle-red:before {
  background-color: #f44a5f;
}
.circle-63.circle-orange:before {
  background-color: #ffb802;
}
.circle-63.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-63.circle-green:before {
  background-color: #00b48c;
}

.circle-64:before {
  -webkit-transform: rotate(50.4deg);
  -moz-transform: rotate(50.4deg);
  -ms-transform: rotate(50.4deg);
  -o-transform: rotate(50.4deg);
  transform: rotate(50.4deg);
}
.circle-64.circle-red:before {
  background-color: #f44a5f;
}
.circle-64.circle-orange:before {
  background-color: #ffb802;
}
.circle-64.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-64.circle-green:before {
  background-color: #00b48c;
}

.circle-65:before {
  -webkit-transform: rotate(54deg);
  -moz-transform: rotate(54deg);
  -ms-transform: rotate(54deg);
  -o-transform: rotate(54deg);
  transform: rotate(54deg);
}
.circle-65.circle-red:before {
  background-color: #f44a5f;
}
.circle-65.circle-orange:before {
  background-color: #ffb802;
}
.circle-65.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-65.circle-green:before {
  background-color: #00b48c;
}

.circle-66:before {
  -webkit-transform: rotate(57.6deg);
  -moz-transform: rotate(57.6deg);
  -ms-transform: rotate(57.6deg);
  -o-transform: rotate(57.6deg);
  transform: rotate(57.6deg);
}
.circle-66.circle-red:before {
  background-color: #f44a5f;
}
.circle-66.circle-orange:before {
  background-color: #ffb802;
}
.circle-66.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-66.circle-green:before {
  background-color: #00b48c;
}

.circle-67:before {
  -webkit-transform: rotate(61.2deg);
  -moz-transform: rotate(61.2deg);
  -ms-transform: rotate(61.2deg);
  -o-transform: rotate(61.2deg);
  transform: rotate(61.2deg);
}
.circle-67.circle-red:before {
  background-color: #f44a5f;
}
.circle-67.circle-orange:before {
  background-color: #ffb802;
}
.circle-67.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-67.circle-green:before {
  background-color: #00b48c;
}

.circle-68:before {
  -webkit-transform: rotate(64.8deg);
  -moz-transform: rotate(64.8deg);
  -ms-transform: rotate(64.8deg);
  -o-transform: rotate(64.8deg);
  transform: rotate(64.8deg);
}
.circle-68.circle-red:before {
  background-color: #f44a5f;
}
.circle-68.circle-orange:before {
  background-color: #ffb802;
}
.circle-68.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-68.circle-green:before {
  background-color: #00b48c;
}

.circle-69:before {
  -webkit-transform: rotate(68.4deg);
  -moz-transform: rotate(68.4deg);
  -ms-transform: rotate(68.4deg);
  -o-transform: rotate(68.4deg);
  transform: rotate(68.4deg);
}
.circle-69.circle-red:before {
  background-color: #f44a5f;
}
.circle-69.circle-orange:before {
  background-color: #ffb802;
}
.circle-69.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-69.circle-green:before {
  background-color: #00b48c;
}

.circle-70:before {
  -webkit-transform: rotate(72deg);
  -moz-transform: rotate(72deg);
  -ms-transform: rotate(72deg);
  -o-transform: rotate(72deg);
  transform: rotate(72deg);
}
.circle-70.circle-red:before {
  background-color: #f44a5f;
}
.circle-70.circle-orange:before {
  background-color: #ffb802;
}
.circle-70.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-70.circle-green:before {
  background-color: #00b48c;
}

.circle-71:before {
  -webkit-transform: rotate(75.6deg);
  -moz-transform: rotate(75.6deg);
  -ms-transform: rotate(75.6deg);
  -o-transform: rotate(75.6deg);
  transform: rotate(75.6deg);
}
.circle-71.circle-red:before {
  background-color: #f44a5f;
}
.circle-71.circle-orange:before {
  background-color: #ffb802;
}
.circle-71.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-71.circle-green:before {
  background-color: #00b48c;
}

.circle-72:before {
  -webkit-transform: rotate(79.2deg);
  -moz-transform: rotate(79.2deg);
  -ms-transform: rotate(79.2deg);
  -o-transform: rotate(79.2deg);
  transform: rotate(79.2deg);
}
.circle-72.circle-red:before {
  background-color: #f44a5f;
}
.circle-72.circle-orange:before {
  background-color: #ffb802;
}
.circle-72.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-72.circle-green:before {
  background-color: #00b48c;
}

.circle-73:before {
  -webkit-transform: rotate(82.8deg);
  -moz-transform: rotate(82.8deg);
  -ms-transform: rotate(82.8deg);
  -o-transform: rotate(82.8deg);
  transform: rotate(82.8deg);
}
.circle-73.circle-red:before {
  background-color: #f44a5f;
}
.circle-73.circle-orange:before {
  background-color: #ffb802;
}
.circle-73.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-73.circle-green:before {
  background-color: #00b48c;
}

.circle-74:before {
  -webkit-transform: rotate(86.4deg);
  -moz-transform: rotate(86.4deg);
  -ms-transform: rotate(86.4deg);
  -o-transform: rotate(86.4deg);
  transform: rotate(86.4deg);
}
.circle-74.circle-red:before {
  background-color: #f44a5f;
}
.circle-74.circle-orange:before {
  background-color: #ffb802;
}
.circle-74.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-74.circle-green:before {
  background-color: #00b48c;
}

.circle-75:before {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}
.circle-75.circle-red:before {
  background-color: #f44a5f;
}
.circle-75.circle-orange:before {
  background-color: #ffb802;
}
.circle-75.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-75.circle-green:before {
  background-color: #00b48c;
}

.circle-76:before {
  -webkit-transform: rotate(93.6deg);
  -moz-transform: rotate(93.6deg);
  -ms-transform: rotate(93.6deg);
  -o-transform: rotate(93.6deg);
  transform: rotate(93.6deg);
}
.circle-76.circle-red:before {
  background-color: #f44a5f;
}
.circle-76.circle-orange:before {
  background-color: #ffb802;
}
.circle-76.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-76.circle-green:before {
  background-color: #00b48c;
}

.circle-77:before {
  -webkit-transform: rotate(97.2deg);
  -moz-transform: rotate(97.2deg);
  -ms-transform: rotate(97.2deg);
  -o-transform: rotate(97.2deg);
  transform: rotate(97.2deg);
}
.circle-77.circle-red:before {
  background-color: #f44a5f;
}
.circle-77.circle-orange:before {
  background-color: #ffb802;
}
.circle-77.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-77.circle-green:before {
  background-color: #00b48c;
}

.circle-78:before {
  -webkit-transform: rotate(100.8deg);
  -moz-transform: rotate(100.8deg);
  -ms-transform: rotate(100.8deg);
  -o-transform: rotate(100.8deg);
  transform: rotate(100.8deg);
}
.circle-78.circle-red:before {
  background-color: #f44a5f;
}
.circle-78.circle-orange:before {
  background-color: #ffb802;
}
.circle-78.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-78.circle-green:before {
  background-color: #00b48c;
}

.circle-79:before {
  -webkit-transform: rotate(104.4deg);
  -moz-transform: rotate(104.4deg);
  -ms-transform: rotate(104.4deg);
  -o-transform: rotate(104.4deg);
  transform: rotate(104.4deg);
}
.circle-79.circle-red:before {
  background-color: #f44a5f;
}
.circle-79.circle-orange:before {
  background-color: #ffb802;
}
.circle-79.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-79.circle-green:before {
  background-color: #00b48c;
}

.circle-80:before {
  -webkit-transform: rotate(108deg);
  -moz-transform: rotate(108deg);
  -ms-transform: rotate(108deg);
  -o-transform: rotate(108deg);
  transform: rotate(108deg);
}
.circle-80.circle-red:before {
  background-color: #f44a5f;
}
.circle-80.circle-orange:before {
  background-color: #ffb802;
}
.circle-80.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-80.circle-green:before {
  background-color: #00b48c;
}

.circle-81:before {
  -webkit-transform: rotate(111.6deg);
  -moz-transform: rotate(111.6deg);
  -ms-transform: rotate(111.6deg);
  -o-transform: rotate(111.6deg);
  transform: rotate(111.6deg);
}
.circle-81.circle-red:before {
  background-color: #f44a5f;
}
.circle-81.circle-orange:before {
  background-color: #ffb802;
}
.circle-81.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-81.circle-green:before {
  background-color: #00b48c;
}

.circle-82:before {
  -webkit-transform: rotate(115.2deg);
  -moz-transform: rotate(115.2deg);
  -ms-transform: rotate(115.2deg);
  -o-transform: rotate(115.2deg);
  transform: rotate(115.2deg);
}
.circle-82.circle-red:before {
  background-color: #f44a5f;
}
.circle-82.circle-orange:before {
  background-color: #ffb802;
}
.circle-82.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-82.circle-green:before {
  background-color: #00b48c;
}

.circle-83:before {
  -webkit-transform: rotate(118.8deg);
  -moz-transform: rotate(118.8deg);
  -ms-transform: rotate(118.8deg);
  -o-transform: rotate(118.8deg);
  transform: rotate(118.8deg);
}
.circle-83.circle-red:before {
  background-color: #f44a5f;
}
.circle-83.circle-orange:before {
  background-color: #ffb802;
}
.circle-83.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-83.circle-green:before {
  background-color: #00b48c;
}

.circle-84:before {
  -webkit-transform: rotate(122.4deg);
  -moz-transform: rotate(122.4deg);
  -ms-transform: rotate(122.4deg);
  -o-transform: rotate(122.4deg);
  transform: rotate(122.4deg);
}
.circle-84.circle-red:before {
  background-color: #f44a5f;
}
.circle-84.circle-orange:before {
  background-color: #ffb802;
}
.circle-84.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-84.circle-green:before {
  background-color: #00b48c;
}

.circle-85:before {
  -webkit-transform: rotate(126deg);
  -moz-transform: rotate(126deg);
  -ms-transform: rotate(126deg);
  -o-transform: rotate(126deg);
  transform: rotate(126deg);
}
.circle-85.circle-red:before {
  background-color: #f44a5f;
}
.circle-85.circle-orange:before {
  background-color: #ffb802;
}
.circle-85.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-85.circle-green:before {
  background-color: #00b48c;
}

.circle-86:before {
  -webkit-transform: rotate(129.6deg);
  -moz-transform: rotate(129.6deg);
  -ms-transform: rotate(129.6deg);
  -o-transform: rotate(129.6deg);
  transform: rotate(129.6deg);
}
.circle-86.circle-red:before {
  background-color: #f44a5f;
}
.circle-86.circle-orange:before {
  background-color: #ffb802;
}
.circle-86.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-86.circle-green:before {
  background-color: #00b48c;
}

.circle-87:before {
  -webkit-transform: rotate(133.2deg);
  -moz-transform: rotate(133.2deg);
  -ms-transform: rotate(133.2deg);
  -o-transform: rotate(133.2deg);
  transform: rotate(133.2deg);
}
.circle-87.circle-red:before {
  background-color: #f44a5f;
}
.circle-87.circle-orange:before {
  background-color: #ffb802;
}
.circle-87.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-87.circle-green:before {
  background-color: #00b48c;
}

.circle-88:before {
  -webkit-transform: rotate(136.8deg);
  -moz-transform: rotate(136.8deg);
  -ms-transform: rotate(136.8deg);
  -o-transform: rotate(136.8deg);
  transform: rotate(136.8deg);
}
.circle-88.circle-red:before {
  background-color: #f44a5f;
}
.circle-88.circle-orange:before {
  background-color: #ffb802;
}
.circle-88.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-88.circle-green:before {
  background-color: #00b48c;
}

.circle-89:before {
  -webkit-transform: rotate(140.4deg);
  -moz-transform: rotate(140.4deg);
  -ms-transform: rotate(140.4deg);
  -o-transform: rotate(140.4deg);
  transform: rotate(140.4deg);
}
.circle-89.circle-red:before {
  background-color: #f44a5f;
}
.circle-89.circle-orange:before {
  background-color: #ffb802;
}
.circle-89.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-89.circle-green:before {
  background-color: #00b48c;
}

.circle-90:before {
  -webkit-transform: rotate(144deg);
  -moz-transform: rotate(144deg);
  -ms-transform: rotate(144deg);
  -o-transform: rotate(144deg);
  transform: rotate(144deg);
}
.circle-90.circle-red:before {
  background-color: #f44a5f;
}
.circle-90.circle-orange:before {
  background-color: #ffb802;
}
.circle-90.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-90.circle-green:before {
  background-color: #00b48c;
}

.circle-91:before {
  -webkit-transform: rotate(147.6deg);
  -moz-transform: rotate(147.6deg);
  -ms-transform: rotate(147.6deg);
  -o-transform: rotate(147.6deg);
  transform: rotate(147.6deg);
}
.circle-91.circle-red:before {
  background-color: #f44a5f;
}
.circle-91.circle-orange:before {
  background-color: #ffb802;
}
.circle-91.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-91.circle-green:before {
  background-color: #00b48c;
}

.circle-92:before {
  -webkit-transform: rotate(151.2deg);
  -moz-transform: rotate(151.2deg);
  -ms-transform: rotate(151.2deg);
  -o-transform: rotate(151.2deg);
  transform: rotate(151.2deg);
}
.circle-92.circle-red:before {
  background-color: #f44a5f;
}
.circle-92.circle-orange:before {
  background-color: #ffb802;
}
.circle-92.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-92.circle-green:before {
  background-color: #00b48c;
}

.circle-93:before {
  -webkit-transform: rotate(154.8deg);
  -moz-transform: rotate(154.8deg);
  -ms-transform: rotate(154.8deg);
  -o-transform: rotate(154.8deg);
  transform: rotate(154.8deg);
}
.circle-93.circle-red:before {
  background-color: #f44a5f;
}
.circle-93.circle-orange:before {
  background-color: #ffb802;
}
.circle-93.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-93.circle-green:before {
  background-color: #00b48c;
}

.circle-94:before {
  -webkit-transform: rotate(158.4deg);
  -moz-transform: rotate(158.4deg);
  -ms-transform: rotate(158.4deg);
  -o-transform: rotate(158.4deg);
  transform: rotate(158.4deg);
}
.circle-94.circle-red:before {
  background-color: #f44a5f;
}
.circle-94.circle-orange:before {
  background-color: #ffb802;
}
.circle-94.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-94.circle-green:before {
  background-color: #00b48c;
}

.circle-95:before {
  -webkit-transform: rotate(162deg);
  -moz-transform: rotate(162deg);
  -ms-transform: rotate(162deg);
  -o-transform: rotate(162deg);
  transform: rotate(162deg);
}
.circle-95.circle-red:before {
  background-color: #f44a5f;
}
.circle-95.circle-orange:before {
  background-color: #ffb802;
}
.circle-95.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-95.circle-green:before {
  background-color: #00b48c;
}

.circle-96:before {
  -webkit-transform: rotate(165.6deg);
  -moz-transform: rotate(165.6deg);
  -ms-transform: rotate(165.6deg);
  -o-transform: rotate(165.6deg);
  transform: rotate(165.6deg);
}
.circle-96.circle-red:before {
  background-color: #f44a5f;
}
.circle-96.circle-orange:before {
  background-color: #ffb802;
}
.circle-96.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-96.circle-green:before {
  background-color: #00b48c;
}

.circle-97:before {
  -webkit-transform: rotate(169.2deg);
  -moz-transform: rotate(169.2deg);
  -ms-transform: rotate(169.2deg);
  -o-transform: rotate(169.2deg);
  transform: rotate(169.2deg);
}
.circle-97.circle-red:before {
  background-color: #f44a5f;
}
.circle-97.circle-orange:before {
  background-color: #ffb802;
}
.circle-97.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-97.circle-green:before {
  background-color: #00b48c;
}

.circle-98:before {
  -webkit-transform: rotate(172.8deg);
  -moz-transform: rotate(172.8deg);
  -ms-transform: rotate(172.8deg);
  -o-transform: rotate(172.8deg);
  transform: rotate(172.8deg);
}
.circle-98.circle-red:before {
  background-color: #f44a5f;
}
.circle-98.circle-orange:before {
  background-color: #ffb802;
}
.circle-98.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-98.circle-green:before {
  background-color: #00b48c;
}

.circle-99:before {
  -webkit-transform: rotate(176.4deg);
  -moz-transform: rotate(176.4deg);
  -ms-transform: rotate(176.4deg);
  -o-transform: rotate(176.4deg);
  transform: rotate(176.4deg);
}
.circle-99.circle-red:before {
  background-color: #f44a5f;
}
.circle-99.circle-orange:before {
  background-color: #ffb802;
}
.circle-99.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-99.circle-green:before {
  background-color: #00b48c;
}

.circle-100:before {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
.circle-100.circle-red:before {
  background-color: #f44a5f;
}
.circle-100.circle-orange:before {
  background-color: #ffb802;
}
.circle-100.circle-yellow:before {
  background-color: #B38D2F;
}
.circle-100.circle-green:before {
  background-color: #00b48c;
}

</style>
